import { render } from "./my-products.vue?vue&type=template&id=4af81af6"
import script from "./my-products.vue?vue&type=script&lang=js"
export * from "./my-products.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__